// extracted by mini-css-extract-plugin
export default {"logo":"youroffers--11j94","placeholder":"youroffers--1amqw","logo__image":"youroffers--1W4_k"};